import React, { ChangeEvent, FC, useContext } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import BaseTextField from '../baseTextField';
import { CustomFormContext } from '../customFormContextProvider';

const ZipCodeField: FC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const customFormContext = useContext(CustomFormContext);
  const [selectedAddress, setSelectedAddress] = customFormContext?.selectedAddress ?? [];
  const inputAttributes = {
    onInput: (event: ChangeEvent<HTMLInputElement>) => {
      if (setSelectedAddress && selectedAddress?.zipcode)
        setSelectedAddress({ ...selectedAddress, zipcode: event.target.value });
    },
  };

  return (
    <BaseTextField
      type="text"
      {...props}
      inputAttributes={inputAttributes}
      value={selectedAddress?.zipcode || props.value}
    />
  );
};

export default ZipCodeField;
